import { Helmet } from "react-helmet-async";
import { SITE } from "../lib/site";

const SITE_URL = "https://dirty-wrenches.com";
const DEFAULT_OG = `${SITE_URL}/logo.jpg`;

export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  schema = null,
}) => {
  const canonical = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | ${SITE.fullName}`
    : `${SITE.fullName} — Import Specialists in Hermiston, OR`;
  const desc =
    description ||
    `Dirty Wrenches Automotive — a small specialist auto shop in Hermiston, Oregon. BMW, Audi, Volkswagen, Mercedes-Benz, Subaru and Porsche experts. We also work on domestics, trucks and motorcycles. No job too small.`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.fullName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {/* Geo */}
      <meta name="geo.region" content="US-OR" />
      <meta name="geo.placename" content="Hermiston" />
      <meta name="geo.position" content="45.8401;-119.2895" />
      <meta name="ICBM" content="45.8401, -119.2895" />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

// Reusable LocalBusiness / AutoRepair schema for the shop
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  name: SITE.fullName,
  alternateName: SITE.name,
  image: DEFAULT_OG,
  url: SITE_URL,
  telephone: SITE.contact.phone,
  email: SITE.contact.email,
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "1055 N 1st Pl, Suite 3A",
    addressLocality: "Hermiston",
    addressRegion: "OR",
    postalCode: "97838",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 45.8401,
    longitude: -119.2895,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "17:00",
    },
  ],
  areaServed: [
    { "@type": "City", name: "Hermiston" },
    { "@type": "City", name: "Pendleton" },
    { "@type": "City", name: "Umatilla" },
    { "@type": "City", name: "Boardman" },
    { "@type": "City", name: "Pasco" },
    { "@type": "City", name: "Kennewick" },
    { "@type": "City", name: "Tri-Cities" },
  ],
  brand: [
    { "@type": "Brand", name: "BMW" },
    { "@type": "Brand", name: "Audi" },
    { "@type": "Brand", name: "Volkswagen" },
    { "@type": "Brand", name: "Mercedes-Benz" },
    { "@type": "Brand", name: "Subaru" },
    { "@type": "Brand", name: "Porsche" },
  ],
  makesOffer: [
    "Diagnostics",
    "Performance Tuning",
    "Engine & Transmission Service",
    "Brakes & Suspension",
    "Maintenance",
  ].map((s) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: s } })),
  foundingDate: "2022",
  slogan: SITE.tagline,
};

export default Seo;
